import { render } from "./newRelRadio.vue?vue&type=template&id=86a0fe96&scoped=true"
import script from "./newRelRadio.vue?vue&type=script&lang=js"
export * from "./newRelRadio.vue?vue&type=script&lang=js"

import "./newRelRadio.vue?vue&type=style&index=0&id=86a0fe96&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86a0fe96"]])

export default __exports__